import { render, staticRenderFns } from "./NightHuntPotion.vue?vue&type=template&id=f1a40d72"
import script from "./NightHuntPotion.vue?vue&type=script&lang=js"
export * from "./NightHuntPotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports